import { api } from '../api/client';
import { USERS } from '../api/endpoints';
import { buildQuery } from '../api/helpers';

export const userService = {
  list: (params = {}) => api.get(`/admin/users${buildQuery(params)}`),
  get: (id) => api.get(USERS.BY_ID(id)),
  create: (body) => api.post(USERS.CREATE, body),
  update: (id, body) => api.patch(USERS.BY_ID(id), body),
  resetPassword: (id, password) =>
    api.post(USERS.RESET_PASSWORD(id), { password }),
};
